<div class="container">
  <environment-status [status]="status" (verifyServiceAvailability)="verifyService()"></environment-status>
  <div class="full-restart-service">
    <div class="full-restart-service__header">
      <div class="full-restart-service__header-info">
        <div class="full-restart-service__header-title">
          {{ "MAINTENANCE.FULL_SERVICE_RESTART" | translate }}
        </div>
        <div class="full-restart-service__header-text">
          {{ "MAINTENANCE.RESTART_TEXT" | translate }}
        </div>
      </div>
      <div>
        <button
          type="button"
          class="bz-space--stack-m bz-btn bz-btn--m"
          [ngClass]="{
            'full-restart-service__header-btn-warning--disabled': isRestartingService,
            'full-restart-service__header-btn-warning': !isRestartingService
          }"
          (click)="restartService()"
          [disabled]="isRestartingService"
        >
          <bzg-icon
            class="bz-space--inline-s"
            [nameIcon]="'icon-warning'"
            [size]="16"
          >
          </bzg-icon>
          <span>{{ "MAINTENANCE.RESTART_SERVICE" | translate }} </span>
        </button>
      </div>
    </div>
  </div>
</div>
